import { useMap } from "react-leaflet";
export default function MapSize({mapFull}){
    const map = useMap();
    window.onresize = () => {
        map.invalidateSize({pan: false, animate: false});
    }
    if(mapFull){
        map.invalidateSize({pan: false, animate: false});
    }
    return null;
}